import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getPowerGenerationRegisterStatusList,
	addNewPowerGenerationRegisterStatus,
	updatePowerGenerationRegisterStatus,
	deletePowerGenerationRegisterStatus,
	getPowerGenerationRegisterStatus,
	getPowerGenerationRegisterStatusCode,
} from '../powerGenerationRegisterStatus/thunk';

export const initialState = {
	itemPowerGenerationRegisterStatusList: [],
	itemPowerGenerationRegisterStatus: null,
	isPowerGenerationRegisterStatusLoading: false,
	isPowerGenerationRegisterStatusSuccess: false,


	powerGenerationRegisterStatusList: [],
	powerGenerationRegisterStatusListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const PowerGenerationRegisterStatusSlice = createSlice({
	name: 'PowerGenerationRegisterStatus',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getPowerGenerationRegisterStatus.fulfilled, (state, action) => {
			state.isPowerGenerationRegisterStatusLoading = false;
			state.isPowerGenerationRegisterStatusSuccess = true;
			state.itemPowerGenerationRegisterStatus = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getPowerGenerationRegisterStatus.pending, state => {
			state.isPowerGenerationRegisterStatusLoading = true;
			state.isPowerGenerationRegisterStatusSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getPowerGenerationRegisterStatus.rejected, (state, action) => {
			state.isPowerGenerationRegisterStatusLoading = false;
			state.isPowerGenerationRegisterStatusSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});
		builder.addCase(getPowerGenerationRegisterStatusCode.fulfilled, (state, action) => {
			state.isPowerGenerationRegisterStatusLoading = false;
			state.isPowerGenerationRegisterStatusSuccess = true;
			state.itemPowerGenerationRegisterStatus = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getPowerGenerationRegisterStatusCode.pending, state => {
			state.isPowerGenerationRegisterStatusLoading = true;
			state.isPowerGenerationRegisterStatusSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});

		builder.addCase(getPowerGenerationRegisterStatusCode.rejected, (state, action) => {
			state.isPowerGenerationRegisterStatusLoading = false;
			state.isPowerGenerationRegisterStatusSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getPowerGenerationRegisterStatusList.pending, state => {
			state.isPowerGenerationRegisterStatusSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getPowerGenerationRegisterStatusList.fulfilled, (state, action) => {
			state.itemPowerGenerationRegisterStatusList = action.payload;
			state.powerGenerationRegisterStatusList = action.payload;
			state.isLoadingList = false;
			state.isPowerGenerationRegisterStatusSuccess = true;

			let powerGenerationRegisterStatusListSelect = [];
			action.payload.map(item =>
				powerGenerationRegisterStatusListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.powerGenerationRegisterStatusListSelect = powerGenerationRegisterStatusListSelect;
		});
		builder.addCase(getPowerGenerationRegisterStatusList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isPowerGenerationRegisterStatusSuccess = true;
		});
		builder.addCase(addNewPowerGenerationRegisterStatus.fulfilled, (state, action) => {
			state.itemPowerGenerationRegisterStatusList.push(action.payload);
			state.powerGenerationRegisterStatusList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewPowerGenerationRegisterStatus.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewPowerGenerationRegisterStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updatePowerGenerationRegisterStatus.fulfilled, (state, action) => {
			state.itemPowerGenerationRegisterStatusList = state.itemPowerGenerationRegisterStatusList.map(powerGenerationRegisterStatus =>
				powerGenerationRegisterStatus.powerGenerationRegisterStatusname === action.payload.old_powerGenerationRegisterStatus
					? { ...powerGenerationRegisterStatus, ...action.payload.updated_powerGenerationRegisterStatus }
					: powerGenerationRegisterStatus
			);
			state.powerGenerationRegisterStatusList = state.powerGenerationRegisterStatusList.map(powerGenerationRegisterStatus =>
				powerGenerationRegisterStatus._id.toString() === action.payload._id.toString()
					? { ...powerGenerationRegisterStatus, ...action.payload }
					: powerGenerationRegisterStatus
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updatePowerGenerationRegisterStatus.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updatePowerGenerationRegisterStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deletePowerGenerationRegisterStatus.fulfilled, (state, action) => {
			state.itemPowerGenerationRegisterStatusList = current(state.itemPowerGenerationRegisterStatusList).filter(
				item => item._id !== action.payload._id
			);
			state.powerGenerationRegisterStatusList = current(state.powerGenerationRegisterStatusList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deletePowerGenerationRegisterStatus.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deletePowerGenerationRegisterStatus.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
		
	},
});

export const { setRequireCloseModal } = PowerGenerationRegisterStatusSlice.actions;

export default PowerGenerationRegisterStatusSlice.reducer;
